import React, { useEffect, useState } from 'react';
import "./pagesLanyard.css";
import Lanyard from '../components/landyard/Lanyard';
import ScrollDown from './ScrollDown';

export default function PagesLanyard() {
    const [scrollEnabled, setScrollEnabled] = useState(false);

    useEffect(() => {
        const isMobile = window.innerWidth <= 768;

        if (isMobile && !scrollEnabled) {
            document.body.classList.add("no-scroll");
        } else {
            document.body.classList.remove("no-scroll");
        }

        const handleScroll = () => {
            if (window.scrollY === 0) {
                setScrollEnabled(false);
                document.body.classList.add("no-scroll");
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            document.body.classList.remove("no-scroll");
        };
    }, [scrollEnabled]);

    const enableScroll = () => {
        setScrollEnabled(true);
        document.body.classList.remove("no-scroll");
    };

    return (
        <>
            <Lanyard position={[0, 0, 15]} gravity={[0, -40, 0]} />
            <ScrollDown onClick={enableScroll} />
        </>
    );
}
